var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppDialog",
    {
      attrs: {
        title: _vm.title,
        width: "1000px",
        loading: _vm.loading,
        height: "auto",
        top: _vm.top,
      },
      on: { success: _vm.sure },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "prizeWinner",
        },
        [
          _c(
            "el-table",
            {
              ref: "elTable",
              staticClass: "myTable",
              staticStyle: { width: "100%" },
              attrs: {
                height: "383px",
                data: _vm.list,
                "header-cell-style": { background: "#F3F3F3" },
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "prizeDrawName",
                  label: "抽奖名称",
                  width: "132",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "prizeOrderId",
                  label: "中奖订单号",
                  width: "120",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "winnerUserName",
                  label: "用户昵称",
                  width: "80",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(_vm.filtersTextPhone(row.winnerUserName)) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "winnerUserPhone",
                  label: "手机号码",
                  width: "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("watchPhoneNumber", {
                          attrs: {
                            "phone-area-code": row.phoneAreaCode,
                            "default-value": row.winnerUserPhone,
                            params: row,
                            "user-id": row.winnerUserId,
                            "get-api": _vm.operationLogsWrite,
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "email", label: "邮箱", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("watchPhoneNumber", {
                          attrs: {
                            "default-value": row.email,
                            params: row,
                            "user-id": row.winnerUserId,
                            "get-api": _vm.operationLogsWriteEmai,
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "createTime", label: "中奖时间", width: "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(_vm._f("filterTime")(row.createTime)) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "giveawayType",
                  label: "奖品类型",
                  width: "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              { 1: "虚拟商品", 2: "实物商品", 3: "优惠券" }[
                                row.giveawayType
                              ]
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "giveawayName",
                  label: "中奖奖品",
                  width: "120",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "amount", label: "数量", width: "120" },
              }),
              _vm.showAction
                ? _c("el-table-column", {
                    attrs: {
                      prop: "prizeIssueStatus",
                      label: "发放状态",
                      width: "120",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    { 1: "未发放", 2: "已发放" }[
                                      row.prizeIssueStatus
                                    ]
                                  ) +
                                  " "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1528245617
                    ),
                  })
                : _vm._e(),
              _vm.showAction
                ? _c("el-table-column", {
                    attrs: { label: "操作", width: "129", fixed: "right" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              row.giveawayType === 2 &&
                              row.prizeIssueStatus === 1
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onhandleSendGoods(row)
                                        },
                                      },
                                    },
                                    [_vm._v("发货")]
                                  )
                                : _vm._e(),
                              row.giveawayType === 2
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onhandleDetail(row)
                                        },
                                      },
                                    },
                                    [_vm._v("详情")]
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      639776171
                    ),
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.currentPage,
                  "page-sizes": [10, 20, 50, 100],
                  "page-size": _vm.pageSize,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.total,
                  "pager-count": 5,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.showAction
        ? _c(
            "div",
            {
              staticClass: "ss-material-box-bottom",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  staticStyle: {
                    height: "32px",
                    "line-height": "32px",
                    "padding-top": "0",
                    "padding-bottom": "0",
                  },
                  attrs: {
                    loading: _vm.downLoading,
                    size: "small",
                    type: "primary",
                  },
                  on: { click: _vm.onHandleDown },
                },
                [
                  !_vm.downLoading
                    ? _c("svg-icon", {
                        attrs: {
                          "class-name": "daochuicon",
                          "icon-class": "daochu",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" 导出名单 "),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c("sendGoods", {
        attrs: { config: _vm.sendGoodsConfig },
        on: { success: _vm.sendGoodsSuccess },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }